export const farmRules = {
    farmName: [
        v => !!v || 'Farm Name is required'
        // (v) => { if (v) return v.length <= 15 || 'Farm Name must be less than 15 characters' },
        // v => !!v.match(/^[a-zA-Z\s]+$/) || 'Only alphabets allowed',
        // (v)=> {if (v) return  /^[A-Za-z]+$/.test(v) || 'Farm Name must contain only alpha characters'},
    ],
    farmRegistrationId: [
        v => !!v || 'Farm Registration Id is required'
        // (v) => { if (v) return v.length <= 15 || 'Farm Name must be less than 15 characters' },
        // v => !!v.match(/^[a-zA-Z\s]+$/) || 'Only alphabets allowed',
        // (v)=> {if (v) return  /^[A-Za-z]+$/.test(v) || 'Farm Name must contain only alpha characters'},
    ],
    farmerRegistrationId: [
        v => !!v || 'Farmer Registration Id is required'
        // (v) => { if (v) return v.length <= 15 || 'Farm Name must be less than 15 characters' },
        // v => !!v.match(/^[a-zA-Z\s]+$/) || 'Only alphabets allowed',
        // (v)=> {if (v) return  /^[A-Za-z]+$/.test(v) || 'Farm Name must contain only alpha characters'},
    ],
    farmType: [
        v => !!v || 'Farm Type is required'
        // (v)=> {if (v) return v.length <= 10 || 'Farm Type must be less than 10 characters'},
        // (v)=> {if (v) return  !Number(v) || 'Farm Type must not contain numbers'}
    ],
    ownerId: [
        v => !!v || 'Farm Owner is required'
        // (v)=> {if (v) return v.length <= 8 || 'Active Ingredients must be less than 8 characters'},
        // (v)=> {if (v) return  !Number(v) || 'Active Ingredients must not contain numbers'}
    ],
    farmOwnershipType: [
        v => !!v || 'Ownership Type is required'
        // (v)=> {if (v) return v.length <= 8 || 'Drug Formate must be less than 8 characters'},
        // (v)=> {if (v) return  !Number(v) || 'Drug Formate must not contain numbers'}
    ],
    province: [
        v => !!v || 'Province is required'
        // (v)=> {if (v) return v.length <= 8 || 'Drug Formate must be less than 8 characters'},
        // (v)=> {if (v) return  !Number(v) || 'Drug Formate must not contain numbers'}
    ],
    farmOwner: [
        v => !!v || 'Farm owner is required'
        // (v)=> {if (v) return v.length <= 8 || 'Drug Formate must be less than 8 characters'},
        // (v)=> {if (v) return  !Number(v) || 'Drug Formate must not contain numbers'}
    ],
    govRegistrationNo: [
        v => !!v || 'Government Registration Number is required'
        // (v) => { if (v) return Number(v) || 'Government Registration Number must contain numbers' },
        // (v) => { if (v) return v > 0 || 'Government Registration Number must be gearter than zero' },
        // (v) => { if (v) return v.length <= 8 || 'Government Registration Number must be less than 8 characters' },
    ],
    contractMating: [
        v => !!v || 'Contract Mating is required'
        // (v) => { if (v) return v.length <= 10 || 'Contract Mating must be less than 10 characters' },
        // (v) => { if (v) return !Number(v) || 'Contract Mating must not contain numbers' }
    ],
    productionSystem: [
        v => !!v || 'Production System is required'
    ],
    cooperativeID: [
        v => !!v || 'Cooperative ID is required'
        // (v) => { if (v) return Number(v) || 'Cooperative ID must contain numbers' },
        // (v) => { if (v) return String(v).length <= 15 || 'Cooperative ID must be less than 15' },
        // (v) => { if (v) return v > 0 || 'Cooperative ID must be gearter than zero' },
    ],
    licenceNumber: [
        v => !!v || 'Licence Number is required'
        // (v) => { if (v) return Number(v) || 'Licence Number must contain numbers' },
        // (v) => { if (v) return v > 0 || 'Licence Number must be gearter than zero' },
        // (v) => { if (v) return String(v).length <= 15 || 'License Number must be less than 15' },
    ],
    licenceED: [
        v => !!v || 'Licence Expiry Date is required'
    ],
    regulatorName: [
        v => !!v || 'Regulator Name is required'
        // (v) => { if (v) return v.length <= 10 || 'Regulator Name must be less than 10 characters' },
        // (v) => { if (v) return !Number(v) || 'Regulator Name must not contain numbers' }
    ],
    regulatorRepName: [
        v => !!v || 'Regulator Representative Name is required'
        // (v) => { if (v) return v.length <= 10 || 'Regulator Representative Name must be less than 10 characters' },
        // (v) => { if (v) return !Number(v) || 'Regulator Representative Name must not contain numbers' }
    ],
    // lat: [
        // v => !!v || 'Latitude Number is required',
        // (v) => { if (v) return Number(v) || 'Latitude Number must not contain characters' }
    // ],
    // log: [
        // v => !!v || 'Longitude Number is required',
        // (v) => { if (v) return Number(v) || 'Longitude Number must contain only numbers' }
    // ],
    country: [
        v => !!v || 'Country is required',
    ],
    state: [
        v => !!v || 'State is required',
    ],
    city: [
        v => !!v || 'City is required',
    ],
    street: [
        v => !!v || 'Postal is required',
    ],
    houseNo: [
        (v) => {
            if ((!Number(v) && v != 0) || (parseInt(v) != v) && v) {
                return "Valid House No is required";
              }
              return true
        }
        // (v) => { if (v) return Number(v) || 'House No must contain only numbers' },
        // (v) => { if ((v.length > 4)) return 'House No cannot be more than 4' }
    ],
    farmSize: [
        v => !!v || 'Farm Size is required',
        (v) => {
            if (!Number(v) && v != 0) {
              return "Farm Size must contain only numbers";
            }
            return true
          },
        // (v) => { if (v) return Number(v) || 'Farm Size must contain only numbers' },
        // (v) => { if ((v.length > 4)) return 'Farm Size cannot be more than 4' }
    ],
    farmSizeUomId: [
        v => !Number(v) || 'Unit is required',
    ],
    address: [
        v => !!v || 'Farm Location is required.',
    ],
}